/**
 * Concordium (CCD) Constants
 * All constants related to Concordium blockchain integration
 */

import config from "../config";

// Chain Configuration
export const CCD_CHAIN_NAME = "Concordium";
export const CCD_NAMESPACE = "ccd";
export const CCD_CHAIN_ID=config.ccd.chainId;
export const CCD_RPC_URL=config.ccd.rpcUrl;

// Currency Configuration
export const CCD_CURRENCY_SYMBOL = "CCD";
export const CCD_CURRENCY_DECIMALS = 6;

// Block Explorer Configuration
export const CCD_BLOCK_EXPLORER_URL = "https://ccdscan.io/";

// WalletConnect Methods
export const CCD_WC_METHODS = {
  REQUEST_ACCOUNTS: "get_account",
  SIGN_MESSAGE: "sign_message",
  SEND_TRANSACTION: "sign_and_send_transaction",
}; 
